import type { VoidFunctionComponent, ChangeEvent } from 'react';
import cx from 'classnames';
import { InputBase, FormLabel, FormLabelVariant } from '../../../generic/Forms';
import type { NumberInputProps } from '../../../generic/Forms/NumberInput';
import type { InputRenderProps } from '../../../generic/Forms/InputBase';
import styles from './TimeoutMinutesInput.module.less';

type Props = Pick<NumberInputProps, 'label' | 'value' | 'isDisabled'> & {
  //  We cast to a number to avoid type issues downstream.
  onChange: (value: number, event?: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

/**
 * TimeoutMinutesInput is like a labeled number input, but with
 * an extra text span which says "minutes".
 */
const TimeoutMinutesInput: VoidFunctionComponent<Props> = ({
  label,
  value,
  isDisabled,
  onChange,
}) => (
  <FormLabel label={label} variant={FormLabelVariant.Filter}>
    <InputBase
      label={label}
      type="number"
      size="small"
      value={value}
      isDisabled={isDisabled}
      onChange={(updatedValue: string, event?: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
        //  Cast to a number, because the input value is a string.
        onChange(Number(updatedValue), event)}
    >
      {(inputBaseProps: InputRenderProps) => (
        <span className={styles.wrapper}>
          <input
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...inputBaseProps}
            className={cx(inputBaseProps.className, styles.input)}
          />
          <span className={styles.text}>
            minutes
          </span>
        </span>
      )}
    </InputBase>
  </FormLabel>
);

export default TimeoutMinutesInput;
